// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"954":"accdc2da","2338":"91221116","3034":"5b6b25f8","4089":"1b225a17","4558":"1f0274fb","4682":"1b225a17","5723":"ff9e0655","6728":"af32a699","9390":"91221116"}[chunkId] + ".chunk.css";
};